import Svg, { Path } from "react-native-svg"
import { useTheme } from "styled-rn"

import { IconProps } from "./SvgIcons"

export const CircledCheck = (props: IconProps) => {
  const theme = useTheme()

  return (
    <Svg width={props.width} viewBox="0 0 17 17">
      <Path
        fill={theme[props.fill]}
        d="M8.5 17a8.504 8.504 0 0 0 6.01-2.49 8.504 8.504 0 0 0 0-12.02 8.504 8.504 0 0 0-12.02 0 8.503 8.503 0 0 0 0 12.02A8.503 8.503 0 0 0 8.5 17ZM3.958 7.544c.42-.409 1.09-.4 1.5.019l1.927 1.976 4.42-4.757a1.063 1.063 0 0 1 1.5-.057 1.067 1.067 0 0 1 .052 1.504l-5.182 5.577h.002a1.06 1.06 0 0 1-1.536.014L3.937 9.047a1.053 1.053 0 0 1-.301-.755c.004-.283.119-.551.32-.748h.002Z"
      />
    </Svg>
  )
}
